export default function() {
    this.initSelectedGive();
}
